
export default "/assets/globe-alt-micro.415a79a1.svg"